export enum TransactionPageEnum {
  VOUCHER_SHOP = 'voucherShop',
}
